import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1.5),
    border: `1px solid ${theme.palette.grey[200]}`
  } as SxProps,

  sectionTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1)
  } as SxProps,

  helperText: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  } as SxProps,

  dimensionsRow: {
    display: 'flex',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  } as SxProps,

  packageTypeRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center'
  } as SxProps,

  deliveryPreferencesTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1)
  } as SxProps,

  toggleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 0)
  } as SxProps,

  toggleLabelContainer: {
    display: 'flex',
    flexDirection: 'column'
  } as SxProps,

  toggleLabel: {
    fontWeight: 500,
    color: theme.palette.text.primary
  } as SxProps,

  toggleDescription: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem'
  } as SxProps,

  divider: {
    marginY: theme.spacing(0.5)
  } as SxProps
}

export default styles
